<template>
  <div class="form_head_top" :style="{height:height,overflow:'auto',padding:'6px 20px','background-color':'#e9ebe9',border:'solid 1px #ddd'}">
    <el-row :gutter="20" >
      <el-col class="form_head_left_buttom" :span="8" v-if="showHeadLeftButton" style="text-align: left;">

      </el-col>
      <el-col :span="8" v-else style="text-align: left;">
        <div style="font-size:24px;line-height: 35px;color: white;">{{$lang('标题')}}：{{businessName}}</div>
      </el-col>
      <el-col class="form_head_buttom" :span="16" style="text-align: right;">
        <!-- icon="fa fa-share-alt"   icon="fa fa-reply" icon="fa fa-file-text-o" icon="fa fa-save" -->
        <el-button v-if="isShowBtn" style="margin-right:4px;" type="default" :key="button.action" :loading="button.loading" v-for="button in buttons"
                    @click="_doAction(button.action)">{{button.name}}
        </el-button>
        <template v-for="item in footerItems" style="display: inline-block;">
          <template v-if="!item.noShow">
            <template v-if="item.handler && item.text">
              <el-button type="default" :icon="item.icon" @click="item.handler">{{item.text}}</el-button>
            </template>
            <template v-else>
              <component :is="item"></component>
            </template>
          </template>
        </template>
      </el-col>
    </el-row>
  </div>
</template>

<script>

  export default {
    components: {

    },
    props: {
      form: Object,
      height: String,
      buttons: Array
    },
    data() {
      return {
        maxHeight:($(window).height()-225)+'px',
        marginLeft:(window.$Env && $Env.formFlowAreaMarginLeft || "0")+"px",
        selectedFlowId: "",
        flows: [],
        extraFlows:[], //外部传的自定义“流向”,[{name:"自定义名字",button:{text:"选择",handler:fn}}]
        selectedUsers: [],
        selectedUserIds:[],
        selUserModel:'',
        dialogVisible: false,
        mulSel:false,
        flowCount: 0,
        loading:false,
        candidateBmIds:[],
        flowCandidateData:[],
        loadedSearchUser:false,
        curSelFlowData:[],
        footerItems:[],
        actions:[],
        autoLoadSingleUser:false,
        submitLoading:false,
        saveLoading:false,
        businessName:"",
        isShowBtn:true,
        showHeadLeftButton:false
      }
    },
    mounted() {
      let me = this;
      if(window.$Env && window.$Env.showHeadLeftButton){
        me.showHeadLeftButton = true;
      }
      if (me.form) {
        let unwatch=me.form.$watch("buttons",{
          handler(btns) {
            if (!_.isEmpty(btns)) {
              me.actions=_.map(btns,"action")
            } else {
              me.actions=[];
            }
          },
          immediate: true
        });
        me.form.$once("hook:beforeDestroy", () => {
          unwatch();
        });
        me.form.renderTaskFormFlowTip(function (flows) {
          if (flows) {
            me.flows = flows;
            me.flowCount = flows.length;
            me.selectedFlowId = me.flows[0] && me.flows[0].id;
            me.flowChange();
            me.$emit("flowReady");
          }
        });
        if(me.form.taskId){
          PF.api.process.getTaskEntityData(me.form.taskId).then(function(res){
            res = res.result?res.result:res;
            if(res.businessName)
              me.businessName = res.businessName;
              if(me.businessName!="" && me.businessName.length>16){
                me.businessName = me.businessName.substring(0,16)+"...";
              }
          })

        }
        //czx 2019-07-12关注表单添加标题
        if(me.form.checkFromName && me.form.checkFromName!="" && me.form.checkFromName!='undefined'){
            me.businessName = me.form.checkFromName;
            if(me.businessName!="" && me.businessName.length>16){
                me.businessName = me.businessName.substring(0,16)+"...";
            }
            me.isShowBtn=false;
        }
      }
    },
    methods: {
      renderTopButtons:function(){
        let me = this;
        let params = {};
        if(me.businessId){
          params.dataId=me.businessId;
        }else{
          let tempId = ""
          if (this.propTempBusinessId) {
            tempId = "_" + this.tempBusinessId;
          }
          params.dataId=tempId;
          if(me.tempTableName){
            params.tempTableName=me.tempTableName;
          }
        }

        params.taskId = me.taskId;
        if (me.taskId) {
          params.processDefinitionId = me.processDefinitionId;
          params.activityId = me.activityId;
        }
        params.processDefinitionKey = me.flowKey;
        params.flowFlag=flowFlag==undefined?true:flowFlag;
        params.forceModuleForm=me.forceModuleForm;
        params.normalFlowBtn=me.normalFlowBtn;
        params.moduleId=me.moduleId;
        params.appId=me.appId;
        params.draftsDocId=me.draftsDocId;
        params.formOpenSource = me.formOpenSource;
        params.taskType=me.taskData && me.taskData.type;
        params.propReadOnly=me.propReadOnly;
        //是否需要锁定编辑
        if(params.taskId && params.dataId && !me.propReadOnly && !(window.$Env && $Env.notOpenDocLockEditMode)){
          params.tryLockEditMode = "1";
        }
        me.mwApi.config.moduleConfig(params).then((data) => {
          let res = data.result;
        })
      },
      flowChange() {
        this.selectedUsers = [];
        this.candidateBmIds = [];
        this.flowCandidateData = [];
        this.curSelFlowData = [];
        this.loadedSearchUser = false;
        if (this.isExtraFlowActive) {
          if (this.selectedFlow.onActive) {
            this.selectedFlow.onActive.call(this,users=>this.selectedUsers=users);
          }
        }
        let params = {};
        this.$emit("flowChange", this,this.selectedUsers,params);
        if(params.returnFalse !== false ){
          if (this.isOverFlow) {
            if(this.form.taskId){
              this.loadSingleUsers(); //运转办结要显示发送人的名称yhq 2019-04-13
            }else{
              this.selectedUsers=[{name: $lang("<流程结束>"), id: "<流程结束>"}]
            }
          }else{
            if(!this.isExtraFlowActive && this.form.taskId){
              this.loadSingleUsers(); //选择流向自动加载用户
            }
          }
        }
      },
       /*isValid(){
        this.$newForm
      },*/

      _doAction: _.debounce(
        async function (action) {
          if(typeof action==='function') {
            action.call(this);
          }else{
            PF.invokeFormAction(action, this.form.$newForm);
          }
        },
        1000,
        {leading: true, trailing: false}
      ),
      formSave(){
        let me=this;
        me.saveLoading=true;
        if(PF.action.flowsave(me.form.$newForm,function(){
          me.saveLoading=false;
        }) === false){
          me.saveLoading=false;
        }
      },
      reject() {
        PF.action.flowreject(this.form.$newForm);
      },
      flowreaded() {
        PF.action.flowreaded(this.form.$newForm);
      },
      deleteUser(user) {
        let index = this.selectedUsers.indexOf(user);
        this.selectedUsers.splice(index, 1);
      },
      searchHandleTaskData: _.debounce(function (query,cb){
        let me = this;
        if (query) {
          this.loading = true;
          if (me.form.taskId) {
            me.doFilterCandidateData(query,cb);
          } else {
            if (!me.form.$newForm.isValid(true)) {
              this.loading = false;
              return;
            }
            me.form.startProcess((d,err) => {
              me.loadSingleUsers(function(){
                me.doFilterCandidateData(query,cb);
              });
            });
          }
        } else {
          cb([]);
        }
      },200,{
        'leading': true,
          'trailing': false
      }),
      doFilterCandidateData(qcon,cb){
        let me = this;
        if(!qcon){
          cb([]);
          return;
        }
        me.doSearchHandleTaskData(function(data){
          if(!qcon)cb([]);
          let ds = _.filter(data,function(d){ return d.name.toLowerCase().indexOf(qcon.toLowerCase()) > -1;}) || [];
          cb(ds);
        });
      },
      setSelCandidateUser:function(row, event, column){
        let me = this;
        let flow = me.getSelectedFlow();
        if(!flow) return;
        if(!flow.options.multipleUnit){
          me.selectedUsers = [row];
          return;
        }
        let r = _.find(me.selectedUsers,function(d){return d.id==row.id});
        if(!r){
          me.selectedUsers.push(row);
        }
      },
      doSearchHandleTaskData(callback){
        let me = this;
        if(me.loadedSearchUser){
          me.loading = false;
          callback(me.flowCandidateData);
          return;
        }
        let flow = me.getSelectedFlow();
        if(!flow){
          return ;
        }
        if(flow.type=="startSubProcess"){
          me.mwApi.process.listPlannedSubByBatchIdAndActivityId(me.form.batchId, flow.activityId).then(v => {
            let removeIds  = [];
            if (v.result) {
              v.result.forEach(v1 => {
                removeIds.push(v1.id);
              })
            }
            //部门运转
            if(flow.options.sendUnit=='DEP'){
              var ds = _.filter(me.curSelFlowData,function(d){ return removeIds.indexOf(d.id) == -1;}) || [];
              me.loading = false;
              me.flowCandidateData = ds;
              me.loadedSearchUser = true;
              callback(me.flowCandidateData);
            }else{
              //人员运转
              let qp = {taskId:me.form.taskId,flowId:me.selectedFlowId};
              qp.candidateBmIds = me.candidateBmIds;
              PF.invoke("s:process.srv.searchHandleTaskData",qp).then(function(ret){
                me.loading = false;
                var ds = _.filter(ret.result,function(d){ return removeIds.indexOf(d.id) == -1;}) || [];
                me.flowCandidateData = ds;
                me.loadedSearchUser = true;
                callback(ds);
              }).catch(()=>{
                me.loading = false;
              })
            }
          })
        }else{
          let qp = {taskId:me.form.taskId,flowId:me.selectedFlowId};
          qp.candidateBmIds = me.candidateBmIds;
          PF.invoke("s:process.srv.searchHandleTaskData",qp).then(function(ret){
            me.loading = false;
            me.flowCandidateData = ret.result || [];
            me.loadedSearchUser = true;
            callback(me.flowCandidateData);
          }).catch(()=>{
            me.loading = false;
          })
        }
      },
      getSelectedFlow(){
        return _.find(this.mixFlows, {id: this.selectedFlowId})
      },
      selectUser() {
        let me = this;
        let flow = me.getSelectedFlow();
        if (flow) flow.userTreeVisible = true;
        if (me.form.taskId) {
          me.dialogVisible = true;
        } else {
          if (!me.form.$newForm.isValid(true)) {
            return;
          }
          me.form.startProcess((d,err) => {
            if(!err)me.dialogVisible = true;
          });
        }
      },
      setSelectUsers(flow) {
        let me = this;
        let tree = me.$refs[flow.id][0];
        //let nodes1 = tree.getSelected();
        let nodes=tree.getSelectNodes(true);
        me.selectedUsers = _.isArray(nodes) ? nodes : [nodes]
        me.dialogVisible=false;
      },
      loadSingleUsers(callback) {
        let me=this;
        if (!me.selectedFlowId) {
          //已经在自动调用了。
          //me.$once("flowReady",()=>me.loadSingleUsers());
          return;
        }
        $.ajax({
          url:`/rest/process/task/flow/${me.form.taskId}/${me.selectedFlowId}`,
          success:function(tree){
            function getDeepNode(node) {
              if(!node || !node.children) return node;
              return getDeepNode(node.children[0])
            }
            function isSingleFlow(tree){
              if(!tree || tree.length!==1)return false;
              if(!tree[0].children || tree[0].children.length===0){
                return !tree[0].hasChild
              }else{
                return isSingleFlow(tree[0].children)
              }
            }
            me.curSelFlowData = tree;
            me.processCandidateBmIds(tree);
            if (isSingleFlow(tree)) {
              me.selectedUsers=[getDeepNode(tree[0])];
            }
            if(_.isFunction(callback)){
              callback(tree);
            }
          }
        });
      },
      processCandidateBmIds(tree){
        let me = this;
        me.candidateBmIds = [];
        if(tree){
          function processBmIds(ds){
            if(ds && ds.length > 0){
              _.each(ds,function(d) {
                if(d.hasReal && d.hasChild){
                  me.candidateBmIds.push(d.id);
                }
                processBmIds(d.children);
              });
            }
          }
          processBmIds(tree);
        }
      },
      submit: _.debounce(function () {
        let me = this;
        if (!me.form.$newForm.isValid(true)) {
          return;
        }
        me.submitLoading=true;
        me.form.startProcess((d, err) => {
          me.submitLoading=false;
          if (!err) {
            if (me.isExtraFlowActive) {
              if (me.selectedFlow.onSubmit) {
                me.selectedFlow.onSubmit.call(me,me.selectedFlow,me.selectedUsers);
              }
              return;
            }
            if (me.form.$newForm.fireEvent("beforecomplete", me.form,me.form, continuation.bind(this)) === false) {
              return false;
            }
            continuation();
            function continuation(){
              me._submit();
            }
          }
        });
      }, 1000, {
        'leading': true,
        'trailing': false
      }),
      _submit() {
        let me = this;

        if (!me.selectedFlowId) {
          PF.message("info", $lang("未获取到符合条件的流向信息"));
          return;
        }
        if (_.isEmpty(me.selectedUsers)) {
          PF.message("info", $lang("请先选择人员"));
          return;
        }
        function doCommit(params) {
          me.form.$newForm.fireEvent("beforedocomplete", params);
          me.submitLoading=true;
          me.mwApi.process.batchCommit(params).then((res) => {
            me.submitLoading=false;
            var data = res.result;
            if (data && !data.success) { //提交意见检查
              if (data.errorType == 'comment') {
                if (data.errorCode == 'comment_check_stop') {
                  PF.message('info', $lang('您还没有填写意见,请填写意见'));

                  return;
                } else if (data.errorCode == 'comment_check_remind') {
                  PF.confirm($lang('您还没有填写意见,您确认是要继续完成？'), $lang('提示'), {type: 'warning'}).then(() => {
                    params['$directSave'] = true;
                    doCommit(params);
                  }).catch(() => {

                  });
                  return;
                }
              } else {
                var errorMsg = '';
                if (data.errorMsg) {
                  errorMsg = '[' + $lang('错误信息') + ':' + data.errorMsg + ']';
                }
                PF.message('info', $lang('完成失败') + errorMsg + '!');
                return;
              }
            } else {
              if (me.form.$newForm.fireEvent("aftercomplete", params,res) === false) {
                return false;
              }
              me.form.formActionComplete();
            }
          }).catch(() => {
            me.submitLoading=false;
          });
        }
        let flowData = me.getSelectedFlow();
        if (me.selectedFlowId && me.selectedUsers.length===0) {
          if (flowData.activityId === 'end') {//下一个节点是结束节点
            let params = {};
            params.type = "complete";
            //params.isAddAttention = me.isAddAttention;
            params.taskId = me.form.taskId;
            params.appId = me.form.appId;
            params.formId = me.form.formId;
            params.formKey = me.form.formKey;
            // params.entityId = me.form.entityId;
            params.businessId = me.form.businessId;
            params.activities = [{flowId: flowData.id, activityId: flowData.activityId}];
            if (me.form.comment) {
              params.$comment = [{id: me.form.commentId, content: me.form.comment, category: me.form.commentCategory}];
            }
            params.formOpenSource = me.params.formOpenSource;

            doCommit(params);
          } else {
            PF.message("info", $lang("请先选择办理人员"));
          }
        } else {
          let activity={};
          activity.flowId=flowData.id;
          activity.activityId=flowData.activityId;
          activity.type=flowData.type;
          activity.options=flowData.options;
          let items=[];
          //部门运转有问题，yhq2019-04-13
          if(flowData.type=="startSubProcess" && activity.options.activityUnit=='group'){
            $.each(me.selectedUsers,function(i,d){
                var uitem={group:d.id};
                uitem.users = [];
                _.each(d.identities,function(u){
                    uitem.users.push({id:u.id});
                })
                items.push(uitem)
            })
          }else{
            _(me.selectedUsers).groupBy("parentId").each((users,parentId)=>{
              if(flowData.options.singleDepartmentRecord!=="true"){
                users.forEach(u=>{
                  items.push({
                    group:parentId,
                    users:[{id:u.id.split("_").pop()}]
                  });
                });
              }else{
                items.push({
                  group:parentId,
                  users:users.map(u=>{return {id:u.id.split("_").pop()}})
                })
              }
            });
          }
          activity.items=items;
          let params = {};
          params.type = "complete";
          //params.isAddAttention = me.isAddAttention;
          params.taskId = me.form.taskId;
          params.appId = me.form.appId;
          params.formId = me.form.formId;
          params.formKey = me.form.formKey;
          //params.entityId = me.form.entityId;
          params.businessId = me.form.businessId;
          params.activities = [activity];
          params.formOpenSource = me.form.formOpenSource;
          doCommit(params);
        }
      },
      extraFlowButtonClick() {
        if(!this.isExtraFlowActive)return;
        let fn=this.selectedFlow.button.handler;
        fn.call(this,(users)=>{
          this.selectedUsers=users;
        });
      }
    },
    computed:{
      mixFlows(){
        return this.flows.concat(this.extraFlows)
      },
      isExtraFlowActive(){
        return this.selectedFlowId && _.findIndex(this.extraFlows,f=>f.id===this.selectedFlowId)>=0
      },
      isOverFlow() {
        return this.selectedFlow && this.selectedFlow.activityName==="结束"
      },
      selectedFlow() {
        return this.getSelectedFlow()
      }
    }
  }
</script>
<style >

  .el-autocomplete-suggestion.flow-action-area-autocomplete{
    width: 260px !important;
  }
  .el-autocomplete-suggestion.flow-action-area-autocomplete li .addr {
    font-size: 12px;
    color: #b4b4b4;
    word-wrap: break-word;
    word-break: normal;
  }
</style>
<style scoped>
  div >>> .el-tag + .el-tag {
    margin-left: 10px;
  }



</style>



// WEBPACK FOOTER //
// src/common/components/extend/form/src/flow-action-top-area.vue